import { buildKTreeDefinitionPayload } from 'pages/SystemTenant/AROKMS/TableDefinition/utils/kTreeDefinitionPayload';
import { TableDefinitionUpsertRequest } from 'types/api/SystemTenant/AROKMS/TableDefinitionTypes';
import {
  RuleParameterOption,
  RuleParameterSchemaItem,
  TableDefinitionEditorValues,
  TableDefinitionKind,
} from '../types';
import { serializeParameterValues } from './parameterSerialization';
import { parseParameterSchema } from './parameterSchema';
import { serializeFieldValidation, supportsFieldValidation } from './tableDefinitionValidation';

export function buildTableDefinitionEditorPayload({
  id,
  subjectId,
  kind,
  values,
  parameterSchema,
  attributeOptions,
}: {
  id?: string | number;
  subjectId: string | number;
  kind: TableDefinitionKind;
  values: TableDefinitionEditorValues;
  parameterSchema?: RuleParameterSchemaItem[];
  attributeOptions?: RuleParameterOption[];
}): TableDefinitionUpsertRequest {
  if (!values.ruleType) throw new Error('Rule type is required.');

  const schema = parameterSchema || parseParameterSchema(values.ruleType.paramsValue);
  const parameters = serializeParameterValues(
    schema,
    values.parameters,
    values.ruleType.code,
    attributeOptions
  );
  const payload: TableDefinitionUpsertRequest = {
    id,
    subjectId,
    ruleTypeId: values.ruleType.value || values.ruleType.id,
    allowEmpty: values.allowEmpty,
    ...parameters,
    ...buildKTreeDefinitionPayload({
      ruleTypeCode: values.ruleType.code,
      ktreeDefinitionId: values.ktreeDefinition?.value,
      inferenceKTreeDefinitionId: values.inferenceKTreeDefinition?.value,
    }),
  };

  if (kind === 'associated-attribute') {
    payload.attributeId = values.attribute?.value;
    payload.validationPattern = supportsFieldValidation(values.ruleType.code)
      ? serializeFieldValidation(values.validation)
      : null;
  } else {
    payload.associatedSubjectId = values.associatedSubject?.value;
    payload.displayName = values.displayName.trim();
  }

  return payload;
}
